var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
/* eslint-disable no-duplicate-imports */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export var UserRole;
(function (UserRole) {
    UserRole["ADMIN"] = "ADMIN";
    UserRole["DEVELOPER"] = "DEVELOPER";
    UserRole["THOUGHT_LEADERSHIP__ACCESS"] = "THOUGHT_LEADERSHIP__ACCESS";
    UserRole["THOUGHT_LEADERSHIP__POST"] = "THOUGHT_LEADERSHIP__POST";
    UserRole["THOUGHT_LEADERSHIP__MODERATE"] = "THOUGHT_LEADERSHIP__MODERATE";
    UserRole["ORGANIZATION"] = "ORGANIZATION";
    UserRole["CAP_TABLE"] = "CAP_TABLE";
})(UserRole || (UserRole = {}));
export var AgreementState;
(function (AgreementState) {
    AgreementState["CANCELED"] = "CANCELED";
    AgreementState["DRAFT"] = "DRAFT";
    AgreementState["ISSUED"] = "ISSUED";
})(AgreementState || (AgreementState = {}));
export var ContentType;
(function (ContentType) {
    ContentType["VIDEO"] = "VIDEO";
    ContentType["ARTICLE"] = "ARTICLE";
})(ContentType || (ContentType = {}));
export var LegalType;
(function (LegalType) {
    LegalType["INC"] = "INC";
    LegalType["LLC"] = "LLC";
    LegalType["LP"] = "LP";
    LegalType["LTD"] = "LTD";
})(LegalType || (LegalType = {}));
export var JurisdictionOfFormation;
(function (JurisdictionOfFormation) {
    JurisdictionOfFormation["CA"] = "CA";
    JurisdictionOfFormation["GB"] = "GB";
    JurisdictionOfFormation["US_AK"] = "US_AK";
    JurisdictionOfFormation["US_AL"] = "US_AL";
    JurisdictionOfFormation["US_AR"] = "US_AR";
    JurisdictionOfFormation["US_AZ"] = "US_AZ";
    JurisdictionOfFormation["US_CA"] = "US_CA";
    JurisdictionOfFormation["US_CO"] = "US_CO";
    JurisdictionOfFormation["US_CT"] = "US_CT";
    JurisdictionOfFormation["US_DC"] = "US_DC";
    JurisdictionOfFormation["US_DE"] = "US_DE";
    JurisdictionOfFormation["US_FL"] = "US_FL";
    JurisdictionOfFormation["US_GA"] = "US_GA";
    JurisdictionOfFormation["US_HI"] = "US_HI";
    JurisdictionOfFormation["US_IA"] = "US_IA";
    JurisdictionOfFormation["US_ID"] = "US_ID";
    JurisdictionOfFormation["US_IL"] = "US_IL";
    JurisdictionOfFormation["US_IN"] = "US_IN";
    JurisdictionOfFormation["US_KS"] = "US_KS";
    JurisdictionOfFormation["US_KY"] = "US_KY";
    JurisdictionOfFormation["US_LA"] = "US_LA";
    JurisdictionOfFormation["US_MA"] = "US_MA";
    JurisdictionOfFormation["US_MD"] = "US_MD";
    JurisdictionOfFormation["US_ME"] = "US_ME";
    JurisdictionOfFormation["US_MI"] = "US_MI";
    JurisdictionOfFormation["US_MN"] = "US_MN";
    JurisdictionOfFormation["US_MO"] = "US_MO";
    JurisdictionOfFormation["US_MS"] = "US_MS";
    JurisdictionOfFormation["US_MT"] = "US_MT";
    JurisdictionOfFormation["US_NC"] = "US_NC";
    JurisdictionOfFormation["US_ND"] = "US_ND";
    JurisdictionOfFormation["US_NE"] = "US_NE";
    JurisdictionOfFormation["US_NH"] = "US_NH";
    JurisdictionOfFormation["US_NJ"] = "US_NJ";
    JurisdictionOfFormation["US_NM"] = "US_NM";
    JurisdictionOfFormation["US_NV"] = "US_NV";
    JurisdictionOfFormation["US_NY"] = "US_NY";
    JurisdictionOfFormation["US_OH"] = "US_OH";
    JurisdictionOfFormation["US_OK"] = "US_OK";
    JurisdictionOfFormation["US_OR"] = "US_OR";
    JurisdictionOfFormation["US_PA"] = "US_PA";
    JurisdictionOfFormation["US_RI"] = "US_RI";
    JurisdictionOfFormation["US_SC"] = "US_SC";
    JurisdictionOfFormation["US_SD"] = "US_SD";
    JurisdictionOfFormation["US_TN"] = "US_TN";
    JurisdictionOfFormation["US_TX"] = "US_TX";
    JurisdictionOfFormation["US_UT"] = "US_UT";
    JurisdictionOfFormation["US_VA"] = "US_VA";
    JurisdictionOfFormation["US_VT"] = "US_VT";
    JurisdictionOfFormation["US_WA"] = "US_WA";
    JurisdictionOfFormation["US_WI"] = "US_WI";
    JurisdictionOfFormation["US_WV"] = "US_WV";
    JurisdictionOfFormation["US_WY"] = "US_WY";
})(JurisdictionOfFormation || (JurisdictionOfFormation = {}));
export var ValuationBasis;
(function (ValuationBasis) {
    ValuationBasis["PRE_MONEY"] = "PRE_MONEY";
    ValuationBasis["POST_MONEY"] = "POST_MONEY";
})(ValuationBasis || (ValuationBasis = {}));
export var ShareClassType;
(function (ShareClassType) {
    ShareClassType["COMMON"] = "COMMON";
    ShareClassType["PREFERRED"] = "PREFERRED";
})(ShareClassType || (ShareClassType = {}));
export var CacheControlScope;
(function (CacheControlScope) {
    CacheControlScope["PUBLIC"] = "PUBLIC";
    CacheControlScope["PRIVATE"] = "PRIVATE";
})(CacheControlScope || (CacheControlScope = {}));
export var ViewerFieldsFragmentDoc = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment ViewerFields on User {\n    id\n    name\n    firstName\n    lastName\n    roles\n    emails {\n      address\n      verified\n    }\n    categories\n  }\n"], ["\n  fragment ViewerFields on User {\n    id\n    name\n    firstName\n    lastName\n    roles\n    emails {\n      address\n      verified\n    }\n    categories\n  }\n"])));
export var ProfilePageUserFragmentDoc = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  fragment ProfilePageUser on User {\n    id\n    name\n    emails {\n      address\n      verified\n    }\n  }\n"], ["\n  fragment ProfilePageUser on User {\n    id\n    name\n    emails {\n      address\n      verified\n    }\n  }\n"])));
export var UserFieldsFragmentDoc = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  fragment UserFields on User {\n    id\n    name\n    emails {\n      verified\n      address\n    }\n    roles\n  }\n"], ["\n  fragment UserFields on User {\n    id\n    name\n    emails {\n      verified\n      address\n    }\n    roles\n  }\n"])));
export var ContentFieldsFragmentDoc = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  fragment ContentFields on Content {\n    id\n    title\n    description\n    type\n    previewUrl\n    imageUrl\n    ... on Content {\n      url\n      public\n      label\n      createdBy {\n        id\n        name\n      }\n      event {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  fragment ContentFields on Content {\n    id\n    title\n    description\n    type\n    previewUrl\n    imageUrl\n    ... on Content {\n      url\n      public\n      label\n      createdBy {\n        id\n        name\n      }\n      event {\n        id\n        name\n      }\n    }\n  }\n"])));
export var EventFieldsFragmentDoc = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  fragment EventFields on Event {\n    id\n    name\n    description\n    published\n    createdBy {\n      id\n    }\n    contents {\n      id\n      title\n      imageUrl\n      description\n      type\n    }\n  }\n"], ["\n  fragment EventFields on Event {\n    id\n    name\n    description\n    published\n    createdBy {\n      id\n    }\n    contents {\n      id\n      title\n      imageUrl\n      description\n      type\n    }\n  }\n"])));
export var OrganizationFieldsFragmentDoc = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  fragment OrganizationFields on Organization {\n    id\n    name\n    description\n    jurisdictionOfFormation\n    legalType\n  }\n"], ["\n  fragment OrganizationFields on Organization {\n    id\n    name\n    description\n    jurisdictionOfFormation\n    legalType\n  }\n"])));
export var CategoryFieldsFragmentDoc = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  fragment CategoryFields on Category {\n    id\n    label\n    comment\n    parent\n  }\n"], ["\n  fragment CategoryFields on Category {\n    id\n    label\n    comment\n    parent\n  }\n"])));
export var ViewerDocument = gql(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  query Viewer {\n    viewer {\n      ...ViewerFields\n    }\n  }\n  ", "\n"], ["\n  query Viewer {\n    viewer {\n      ...ViewerFields\n    }\n  }\n  ", "\n"])), ViewerFieldsFragmentDoc);
/**
 * __useViewerQuery__
 *
 * To run a query within a React component, call `useViewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useViewerQuery(baseOptions) {
    return Apollo.useQuery(ViewerDocument, baseOptions);
}
export function useViewerLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(ViewerDocument, baseOptions);
}
export function refetchViewerQuery(variables) {
    return { query: ViewerDocument, variables: variables };
}
export var UpdateUserDocument = gql(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  mutation UpdateUser($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateUser($input: UpdateUserInput!) {\n    updateUser(input: $input) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"])), ProfilePageUserFragmentDoc);
/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions) {
    return Apollo.useMutation(UpdateUserDocument, baseOptions);
}
export var AddEmailDocument = gql(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  mutation AddEmail($email: String!) {\n    addEmail(email: $email) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AddEmail($email: String!) {\n    addEmail(email: $email) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"])), ProfilePageUserFragmentDoc);
/**
 * __useAddEmailMutation__
 *
 * To run a mutation, you first call `useAddEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailMutation, { data, loading, error }] = useAddEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAddEmailMutation(baseOptions) {
    return Apollo.useMutation(AddEmailDocument, baseOptions);
}
export var RemoveEmailDocument = gql(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  mutation RemoveEmail($email: String!) {\n    removeEmail(email: $email) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation RemoveEmail($email: String!) {\n    removeEmail(email: $email) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"])), ProfilePageUserFragmentDoc);
/**
 * __useRemoveEmailMutation__
 *
 * To run a mutation, you first call `useRemoveEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmailMutation, { data, loading, error }] = useRemoveEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRemoveEmailMutation(baseOptions) {
    return Apollo.useMutation(RemoveEmailDocument, baseOptions);
}
export var VerifyEmailDocument = gql(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  mutation VerifyEmail($token: String!) {\n    verifyEmail(token: $token) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation VerifyEmail($token: String!) {\n    verifyEmail(token: $token) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"])), ProfilePageUserFragmentDoc);
/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyEmailMutation(baseOptions) {
    return Apollo.useMutation(VerifyEmailDocument, baseOptions);
}
export var SendVerificationEmailDocument = gql(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  mutation SendVerificationEmail($email: String!) {\n    sendVerificationEmail(email: $email) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation SendVerificationEmail($email: String!) {\n    sendVerificationEmail(email: $email) {\n      user {\n        ...ProfilePageUser\n      }\n    }\n  }\n  ", "\n"])), ProfilePageUserFragmentDoc);
/**
 * __useSendVerificationEmailMutation__
 *
 * To run a mutation, you first call `useSendVerificationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendVerificationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendVerificationEmailMutation, { data, loading, error }] = useSendVerificationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendVerificationEmailMutation(baseOptions) {
    return Apollo.useMutation(SendVerificationEmailDocument, baseOptions);
}
export var AdminUserDetailsDocument = gql(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  query AdminUserDetails($id: ID!) {\n    user(id: $id) {\n      id\n      name\n      roles\n      organizations {\n        name\n      }\n      emails {\n        address\n        verified\n      }\n    }\n  }\n"], ["\n  query AdminUserDetails($id: ID!) {\n    user(id: $id) {\n      id\n      name\n      roles\n      organizations {\n        name\n      }\n      emails {\n        address\n        verified\n      }\n    }\n  }\n"])));
/**
 * __useAdminUserDetailsQuery__
 *
 * To run a query within a React component, call `useAdminUserDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAdminUserDetailsQuery(baseOptions) {
    return Apollo.useQuery(AdminUserDetailsDocument, baseOptions);
}
export function useAdminUserDetailsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(AdminUserDetailsDocument, baseOptions);
}
export function refetchAdminUserDetailsQuery(variables) {
    return { query: AdminUserDetailsDocument, variables: variables };
}
export var AdminUserListDocument = gql(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n  query AdminUserList {\n    users {\n      ...UserFields\n    }\n  }\n  ", "\n"], ["\n  query AdminUserList {\n    users {\n      ...UserFields\n    }\n  }\n  ", "\n"])), UserFieldsFragmentDoc);
/**
 * __useAdminUserListQuery__
 *
 * To run a query within a React component, call `useAdminUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminUserListQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdminUserListQuery(baseOptions) {
    return Apollo.useQuery(AdminUserListDocument, baseOptions);
}
export function useAdminUserListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(AdminUserListDocument, baseOptions);
}
export function refetchAdminUserListQuery(variables) {
    return { query: AdminUserListDocument, variables: variables };
}
export var AddRoleDocument = gql(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n  mutation AddRole($input: AddRoleInput!) {\n    addRole(input: $input) {\n      user {\n        ...UserFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation AddRole($input: AddRoleInput!) {\n    addRole(input: $input) {\n      user {\n        ...UserFields\n      }\n    }\n  }\n  ", "\n"])), UserFieldsFragmentDoc);
/**
 * __useAddRoleMutation__
 *
 * To run a mutation, you first call `useAddRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRoleMutation, { data, loading, error }] = useAddRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddRoleMutation(baseOptions) {
    return Apollo.useMutation(AddRoleDocument, baseOptions);
}
export var RemoveRoleDocument = gql(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  mutation RemoveRole($input: RemoveRoleInput!) {\n    removeRole(input: $input) {\n      user {\n        ...UserFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation RemoveRole($input: RemoveRoleInput!) {\n    removeRole(input: $input) {\n      user {\n        ...UserFields\n      }\n    }\n  }\n  ", "\n"])), UserFieldsFragmentDoc);
/**
 * __useRemoveRoleMutation__
 *
 * To run a mutation, you first call `useRemoveRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRoleMutation, { data, loading, error }] = useRemoveRoleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveRoleMutation(baseOptions) {
    return Apollo.useMutation(RemoveRoleDocument, baseOptions);
}
export var CapTableDocument = gql(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  query CapTable($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      safeTerms {\n        id\n        name\n        discount\n        valuationCap\n        safes {\n          id\n          state\n          principal\n          holder {\n            id\n            name\n          }\n        }\n      }\n      debtTerms {\n        id\n        name\n        discount\n        valuationCap\n        interest\n        maturityDate\n        debtNotes {\n          id\n          state\n          principal\n          holder {\n            id\n            name\n          }\n        }\n      }\n      optionPlans {\n        id\n        name\n        issuedOptions\n        planSize\n        shareClass {\n          id\n          name\n        }\n        optionGrants {\n          id\n          quantity\n          state\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n        }\n      }\n      shareClasses {\n        id\n        name\n        shareCertificates {\n          id\n          state\n          quantity\n          amountPaid\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query CapTable($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      safeTerms {\n        id\n        name\n        discount\n        valuationCap\n        safes {\n          id\n          state\n          principal\n          holder {\n            id\n            name\n          }\n        }\n      }\n      debtTerms {\n        id\n        name\n        discount\n        valuationCap\n        interest\n        maturityDate\n        debtNotes {\n          id\n          state\n          principal\n          holder {\n            id\n            name\n          }\n        }\n      }\n      optionPlans {\n        id\n        name\n        issuedOptions\n        planSize\n        shareClass {\n          id\n          name\n        }\n        optionGrants {\n          id\n          quantity\n          state\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n        }\n      }\n      shareClasses {\n        id\n        name\n        shareCertificates {\n          id\n          state\n          quantity\n          amountPaid\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCapTableQuery__
 *
 * To run a query within a React component, call `useCapTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapTableQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useCapTableQuery(baseOptions) {
    return Apollo.useQuery(CapTableDocument, baseOptions);
}
export function useCapTableLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(CapTableDocument, baseOptions);
}
export function refetchCapTableQuery(variables) {
    return { query: CapTableDocument, variables: variables };
}
export var ConvertiblesPageDocument = gql(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n  query ConvertiblesPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      debtTerms {\n        id\n        name\n        interest\n        discount\n        maturityDate\n        valuationCap\n        totalPrincipal\n        debtNotes {\n          id\n          issuedAt\n          holder {\n            __typename\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          sequenceNumber\n          principal\n        }\n      }\n    }\n  }\n"], ["\n  query ConvertiblesPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      debtTerms {\n        id\n        name\n        interest\n        discount\n        maturityDate\n        valuationCap\n        totalPrincipal\n        debtNotes {\n          id\n          issuedAt\n          holder {\n            __typename\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          sequenceNumber\n          principal\n        }\n      }\n    }\n  }\n"])));
/**
 * __useConvertiblesPageQuery__
 *
 * To run a query within a React component, call `useConvertiblesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useConvertiblesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConvertiblesPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useConvertiblesPageQuery(baseOptions) {
    return Apollo.useQuery(ConvertiblesPageDocument, baseOptions);
}
export function useConvertiblesPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(ConvertiblesPageDocument, baseOptions);
}
export function refetchConvertiblesPageQuery(variables) {
    return { query: ConvertiblesPageDocument, variables: variables };
}
export var DebtTermsPageDocument = gql(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  query DebtTermsPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      debtTerms {\n        id\n        name\n        discount\n        interest\n        maturityDate\n        valuationCap\n        totalPrincipal\n        debtNotes {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query DebtTermsPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      debtTerms {\n        id\n        name\n        discount\n        interest\n        maturityDate\n        valuationCap\n        totalPrincipal\n        debtNotes {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useDebtTermsPageQuery__
 *
 * To run a query within a React component, call `useDebtTermsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebtTermsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebtTermsPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDebtTermsPageQuery(baseOptions) {
    return Apollo.useQuery(DebtTermsPageDocument, baseOptions);
}
export function useDebtTermsPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(DebtTermsPageDocument, baseOptions);
}
export function refetchDebtTermsPageQuery(variables) {
    return { query: DebtTermsPageDocument, variables: variables };
}
export var UpdateDebtTermPageDocument = gql(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  query UpdateDebtTermPage($debtTermId: ID!) {\n    debtTerm(id: $debtTermId) {\n      id\n      name\n      discount\n      interest\n      organization {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query UpdateDebtTermPage($debtTermId: ID!) {\n    debtTerm(id: $debtTermId) {\n      id\n      name\n      discount\n      interest\n      organization {\n        id\n        name\n      }\n    }\n  }\n"])));
/**
 * __useUpdateDebtTermPageQuery__
 *
 * To run a query within a React component, call `useUpdateDebtTermPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateDebtTermPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateDebtTermPageQuery({
 *   variables: {
 *      debtTermId: // value for 'debtTermId'
 *   },
 * });
 */
export function useUpdateDebtTermPageQuery(baseOptions) {
    return Apollo.useQuery(UpdateDebtTermPageDocument, baseOptions);
}
export function useUpdateDebtTermPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateDebtTermPageDocument, baseOptions);
}
export function refetchUpdateDebtTermPageQuery(variables) {
    return { query: UpdateDebtTermPageDocument, variables: variables };
}
export var DebtNotePageDocument = gql(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  query DebtNotePage($debtNoteId: ID!) {\n    debtNote(id: $debtNoteId) {\n      id\n      issuedAt\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      state\n      principal\n      sequenceNumber\n      remarks\n      debtTerm {\n        id\n        name\n        valuationCap\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query DebtNotePage($debtNoteId: ID!) {\n    debtNote(id: $debtNoteId) {\n      id\n      issuedAt\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      state\n      principal\n      sequenceNumber\n      remarks\n      debtTerm {\n        id\n        name\n        valuationCap\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useDebtNotePageQuery__
 *
 * To run a query within a React component, call `useDebtNotePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebtNotePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebtNotePageQuery({
 *   variables: {
 *      debtNoteId: // value for 'debtNoteId'
 *   },
 * });
 */
export function useDebtNotePageQuery(baseOptions) {
    return Apollo.useQuery(DebtNotePageDocument, baseOptions);
}
export function useDebtNotePageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(DebtNotePageDocument, baseOptions);
}
export function refetchDebtNotePageQuery(variables) {
    return { query: DebtNotePageDocument, variables: variables };
}
export var UpdateDebtNotePageDocument = gql(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n  query UpdateDebtNotePage($debtNoteId: ID!) {\n    debtNote(id: $debtNoteId) {\n      id\n      issuedAt\n      principal\n      remarks\n      debtTerm {\n        id\n        totalPrincipal\n        debtNotes {\n          id\n          state\n          principal\n        }\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query UpdateDebtNotePage($debtNoteId: ID!) {\n    debtNote(id: $debtNoteId) {\n      id\n      issuedAt\n      principal\n      remarks\n      debtTerm {\n        id\n        totalPrincipal\n        debtNotes {\n          id\n          state\n          principal\n        }\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateDebtNotePageQuery__
 *
 * To run a query within a React component, call `useUpdateDebtNotePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateDebtNotePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateDebtNotePageQuery({
 *   variables: {
 *      debtNoteId: // value for 'debtNoteId'
 *   },
 * });
 */
export function useUpdateDebtNotePageQuery(baseOptions) {
    return Apollo.useQuery(UpdateDebtNotePageDocument, baseOptions);
}
export function useUpdateDebtNotePageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateDebtNotePageDocument, baseOptions);
}
export function refetchUpdateDebtNotePageQuery(variables) {
    return { query: UpdateDebtNotePageDocument, variables: variables };
}
export var CreateDebtTermDocument = gql(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  mutation CreateDebtTerm($input: CreateDebtTermInput!) {\n    createDebtTerm(input: $input) {\n      debtTerm {\n        id\n        debtNotes {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateDebtTerm($input: CreateDebtTermInput!) {\n    createDebtTerm(input: $input) {\n      debtTerm {\n        id\n        debtNotes {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateDebtTermMutation__
 *
 * To run a mutation, you first call `useCreateDebtTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDebtTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDebtTermMutation, { data, loading, error }] = useCreateDebtTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDebtTermMutation(baseOptions) {
    return Apollo.useMutation(CreateDebtTermDocument, baseOptions);
}
export var UpdateDebtTermDocument = gql(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n  mutation UpdateDebtTerm($input: UpdateDebtTermInput!) {\n    updateDebtTerm(input: $input) {\n      debtTerm {\n        id\n        name\n        discount\n        interest\n      }\n    }\n  }\n"], ["\n  mutation UpdateDebtTerm($input: UpdateDebtTermInput!) {\n    updateDebtTerm(input: $input) {\n      debtTerm {\n        id\n        name\n        discount\n        interest\n      }\n    }\n  }\n"])));
/**
 * __useUpdateDebtTermMutation__
 *
 * To run a mutation, you first call `useUpdateDebtTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDebtTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDebtTermMutation, { data, loading, error }] = useUpdateDebtTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDebtTermMutation(baseOptions) {
    return Apollo.useMutation(UpdateDebtTermDocument, baseOptions);
}
export var DeleteDebtTermDocument = gql(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n  mutation DeleteDebtTerm($input: DeleteDebtTermInput!) {\n    deleteDebtTerm(input: $input) {\n      debtTerm {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteDebtTerm($input: DeleteDebtTermInput!) {\n    deleteDebtTerm(input: $input) {\n      debtTerm {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteDebtTermMutation__
 *
 * To run a mutation, you first call `useDeleteDebtTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDebtTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDebtTermMutation, { data, loading, error }] = useDeleteDebtTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDebtTermMutation(baseOptions) {
    return Apollo.useMutation(DeleteDebtTermDocument, baseOptions);
}
export var CreateDebtNoteDocument = gql(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  mutation CreateDebtNote($input: CreateDebtNoteInput!) {\n    createDebtNote(input: $input) {\n      debtNote {\n        id\n      }\n    }\n  }\n"], ["\n  mutation CreateDebtNote($input: CreateDebtNoteInput!) {\n    createDebtNote(input: $input) {\n      debtNote {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateDebtNoteMutation__
 *
 * To run a mutation, you first call `useCreateDebtNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDebtNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDebtNoteMutation, { data, loading, error }] = useCreateDebtNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDebtNoteMutation(baseOptions) {
    return Apollo.useMutation(CreateDebtNoteDocument, baseOptions);
}
export var UpdateDebtNoteDocument = gql(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  mutation UpdateDebtNote($input: UpdateDebtNoteInput!) {\n    updateDebtNote(input: $input) {\n      debtNote {\n        id\n        issuedAt\n        holder {\n          id\n        }\n        state\n        sequenceNumber\n        principal\n        remarks\n      }\n    }\n  }\n"], ["\n  mutation UpdateDebtNote($input: UpdateDebtNoteInput!) {\n    updateDebtNote(input: $input) {\n      debtNote {\n        id\n        issuedAt\n        holder {\n          id\n        }\n        state\n        sequenceNumber\n        principal\n        remarks\n      }\n    }\n  }\n"])));
/**
 * __useUpdateDebtNoteMutation__
 *
 * To run a mutation, you first call `useUpdateDebtNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDebtNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDebtNoteMutation, { data, loading, error }] = useUpdateDebtNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDebtNoteMutation(baseOptions) {
    return Apollo.useMutation(UpdateDebtNoteDocument, baseOptions);
}
export var DeleteDebtNoteDocument = gql(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n  mutation DeleteDebtNote($input: DeleteDebtNoteInput!) {\n    deleteDebtNote(input: $input) {\n      debtNote {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteDebtNote($input: DeleteDebtNoteInput!) {\n    deleteDebtNote(input: $input) {\n      debtNote {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteDebtNoteMutation__
 *
 * To run a mutation, you first call `useDeleteDebtNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDebtNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDebtNoteMutation, { data, loading, error }] = useDeleteDebtNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDebtNoteMutation(baseOptions) {
    return Apollo.useMutation(DeleteDebtNoteDocument, baseOptions);
}
export var CancelDebtNoteDocument = gql(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n  mutation CancelDebtNote($input: CancelDebtNoteInput!) {\n    cancelDebtNote(input: $input) {\n      debtNote {\n        id\n        state\n      }\n    }\n  }\n"], ["\n  mutation CancelDebtNote($input: CancelDebtNoteInput!) {\n    cancelDebtNote(input: $input) {\n      debtNote {\n        id\n        state\n      }\n    }\n  }\n"])));
/**
 * __useCancelDebtNoteMutation__
 *
 * To run a mutation, you first call `useCancelDebtNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelDebtNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelDebtNoteMutation, { data, loading, error }] = useCancelDebtNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelDebtNoteMutation(baseOptions) {
    return Apollo.useMutation(CancelDebtNoteDocument, baseOptions);
}
export var IssueDebtNoteDocument = gql(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n  mutation IssueDebtNote($input: IssueDebtNoteInput!) {\n    issueDebtNote(input: $input) {\n      debtNote {\n        id\n        state\n      }\n    }\n  }\n"], ["\n  mutation IssueDebtNote($input: IssueDebtNoteInput!) {\n    issueDebtNote(input: $input) {\n      debtNote {\n        id\n        state\n      }\n    }\n  }\n"])));
/**
 * __useIssueDebtNoteMutation__
 *
 * To run a mutation, you first call `useIssueDebtNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueDebtNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueDebtNoteMutation, { data, loading, error }] = useIssueDebtNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueDebtNoteMutation(baseOptions) {
    return Apollo.useMutation(IssueDebtNoteDocument, baseOptions);
}
export var OptionsPageDocument = gql(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n  query OptionsPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      shareClasses {\n        id\n        name\n        authorizedShares\n        draftedShares\n        issuedShares\n        optionPoolShares\n      }\n      optionPlans {\n        id\n        shareClass {\n          id\n          name\n        }\n        name\n        planSize\n        purchasePrice\n        exercisePrice\n        draftedOptions\n        issuedOptions\n        optionGrants {\n          id\n          issuedAt\n          holder {\n            __typename\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          quantity\n          purchasePrice\n          exercisePrice\n          remarks\n        }\n      }\n    }\n  }\n"], ["\n  query OptionsPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      shareClasses {\n        id\n        name\n        authorizedShares\n        draftedShares\n        issuedShares\n        optionPoolShares\n      }\n      optionPlans {\n        id\n        shareClass {\n          id\n          name\n        }\n        name\n        planSize\n        purchasePrice\n        exercisePrice\n        draftedOptions\n        issuedOptions\n        optionGrants {\n          id\n          issuedAt\n          holder {\n            __typename\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          quantity\n          purchasePrice\n          exercisePrice\n          remarks\n        }\n      }\n    }\n  }\n"])));
/**
 * __useOptionsPageQuery__
 *
 * To run a query within a React component, call `useOptionsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOptionsPageQuery(baseOptions) {
    return Apollo.useQuery(OptionsPageDocument, baseOptions);
}
export function useOptionsPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(OptionsPageDocument, baseOptions);
}
export function refetchOptionsPageQuery(variables) {
    return { query: OptionsPageDocument, variables: variables };
}
export var UpdateOptionPlanPageDocument = gql(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n  query UpdateOptionPlanPage($optionPlanId: ID!) {\n    optionPlan(id: $optionPlanId) {\n      name\n      planSize\n      purchasePrice\n      exercisePrice\n      shareClass {\n        id\n        name\n        organization {\n          id\n          name\n          shareClasses {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query UpdateOptionPlanPage($optionPlanId: ID!) {\n    optionPlan(id: $optionPlanId) {\n      name\n      planSize\n      purchasePrice\n      exercisePrice\n      shareClass {\n        id\n        name\n        organization {\n          id\n          name\n          shareClasses {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateOptionPlanPageQuery__
 *
 * To run a query within a React component, call `useUpdateOptionPlanPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionPlanPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateOptionPlanPageQuery({
 *   variables: {
 *      optionPlanId: // value for 'optionPlanId'
 *   },
 * });
 */
export function useUpdateOptionPlanPageQuery(baseOptions) {
    return Apollo.useQuery(UpdateOptionPlanPageDocument, baseOptions);
}
export function useUpdateOptionPlanPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateOptionPlanPageDocument, baseOptions);
}
export function refetchUpdateOptionPlanPageQuery(variables) {
    return { query: UpdateOptionPlanPageDocument, variables: variables };
}
export var OptionGrantPageDocument = gql(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n  query OptionGrantPage($optionGrantId: ID!) {\n    optionGrant(id: $optionGrantId) {\n      id\n      issuedAt\n      optionPlan {\n        id\n        name\n        shareClass {\n          id\n          organization {\n            id\n            name\n          }\n        }\n      }\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      state\n      quantity\n      purchasePrice\n      exercisePrice\n      remarks\n    }\n  }\n"], ["\n  query OptionGrantPage($optionGrantId: ID!) {\n    optionGrant(id: $optionGrantId) {\n      id\n      issuedAt\n      optionPlan {\n        id\n        name\n        shareClass {\n          id\n          organization {\n            id\n            name\n          }\n        }\n      }\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      state\n      quantity\n      purchasePrice\n      exercisePrice\n      remarks\n    }\n  }\n"])));
/**
 * __useOptionGrantPageQuery__
 *
 * To run a query within a React component, call `useOptionGrantPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionGrantPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionGrantPageQuery({
 *   variables: {
 *      optionGrantId: // value for 'optionGrantId'
 *   },
 * });
 */
export function useOptionGrantPageQuery(baseOptions) {
    return Apollo.useQuery(OptionGrantPageDocument, baseOptions);
}
export function useOptionGrantPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(OptionGrantPageDocument, baseOptions);
}
export function refetchOptionGrantPageQuery(variables) {
    return { query: OptionGrantPageDocument, variables: variables };
}
export var UpdateOptionGrantPageDocument = gql(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n  query UpdateOptionGrantPage($optionGrantId: ID!) {\n    optionGrant(id: $optionGrantId) {\n      id\n      issuedAt\n      quantity\n      state\n      purchasePrice\n      exercisePrice\n      remarks\n      holder {\n        id\n        name\n      }\n      optionPlan {\n        id\n        draftedOptions\n        shareClass {\n          id\n          name\n          organization {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query UpdateOptionGrantPage($optionGrantId: ID!) {\n    optionGrant(id: $optionGrantId) {\n      id\n      issuedAt\n      quantity\n      state\n      purchasePrice\n      exercisePrice\n      remarks\n      holder {\n        id\n        name\n      }\n      optionPlan {\n        id\n        draftedOptions\n        shareClass {\n          id\n          name\n          organization {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateOptionGrantPageQuery__
 *
 * To run a query within a React component, call `useUpdateOptionGrantPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionGrantPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateOptionGrantPageQuery({
 *   variables: {
 *      optionGrantId: // value for 'optionGrantId'
 *   },
 * });
 */
export function useUpdateOptionGrantPageQuery(baseOptions) {
    return Apollo.useQuery(UpdateOptionGrantPageDocument, baseOptions);
}
export function useUpdateOptionGrantPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateOptionGrantPageDocument, baseOptions);
}
export function refetchUpdateOptionGrantPageQuery(variables) {
    return { query: UpdateOptionGrantPageDocument, variables: variables };
}
export var CreateOptionPlanDocument = gql(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n  mutation CreateOptionPlan($input: CreateOptionPlanInput!) {\n    createOptionPlan(input: $input) {\n      optionPlan {\n        id\n        name\n        shareClass {\n          id\n          name\n        }\n        planSize\n        purchasePrice\n        exercisePrice\n        optionGrants {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateOptionPlan($input: CreateOptionPlanInput!) {\n    createOptionPlan(input: $input) {\n      optionPlan {\n        id\n        name\n        shareClass {\n          id\n          name\n        }\n        planSize\n        purchasePrice\n        exercisePrice\n        optionGrants {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateOptionPlanMutation__
 *
 * To run a mutation, you first call `useCreateOptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOptionPlanMutation, { data, loading, error }] = useCreateOptionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOptionPlanMutation(baseOptions) {
    return Apollo.useMutation(CreateOptionPlanDocument, baseOptions);
}
export var UpdateOptionPlanDocument = gql(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n  mutation UpdateOptionPlan($input: UpdateOptionPlanInput!) {\n    updateOptionPlan(input: $input) {\n      optionPlan {\n        id\n        shareClass {\n          id\n        }\n        name\n        purchasePrice\n        exercisePrice\n      }\n    }\n  }\n"], ["\n  mutation UpdateOptionPlan($input: UpdateOptionPlanInput!) {\n    updateOptionPlan(input: $input) {\n      optionPlan {\n        id\n        shareClass {\n          id\n        }\n        name\n        purchasePrice\n        exercisePrice\n      }\n    }\n  }\n"])));
/**
 * __useUpdateOptionPlanMutation__
 *
 * To run a mutation, you first call `useUpdateOptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptionPlanMutation, { data, loading, error }] = useUpdateOptionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOptionPlanMutation(baseOptions) {
    return Apollo.useMutation(UpdateOptionPlanDocument, baseOptions);
}
export var DeleteOptionPlanDocument = gql(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n  mutation DeleteOptionPlan($input: DeleteOptionPlanInput!) {\n    deleteOptionPlan(input: $input) {\n      optionPlan {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteOptionPlan($input: DeleteOptionPlanInput!) {\n    deleteOptionPlan(input: $input) {\n      optionPlan {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteOptionPlanMutation__
 *
 * To run a mutation, you first call `useDeleteOptionPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOptionPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOptionPlanMutation, { data, loading, error }] = useDeleteOptionPlanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOptionPlanMutation(baseOptions) {
    return Apollo.useMutation(DeleteOptionPlanDocument, baseOptions);
}
export var CreateOptionGrantDocument = gql(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n  mutation CreateOptionGrant($input: CreateOptionGrantInput!) {\n    createOptionGrant(input: $input) {\n      optionGrant {\n        id\n      }\n    }\n  }\n"], ["\n  mutation CreateOptionGrant($input: CreateOptionGrantInput!) {\n    createOptionGrant(input: $input) {\n      optionGrant {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateOptionGrantMutation__
 *
 * To run a mutation, you first call `useCreateOptionGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOptionGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOptionGrantMutation, { data, loading, error }] = useCreateOptionGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOptionGrantMutation(baseOptions) {
    return Apollo.useMutation(CreateOptionGrantDocument, baseOptions);
}
export var UpdateOptionGrantDocument = gql(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n  mutation UpdateOptionGrant($input: UpdateOptionGrantInput!) {\n    updateOptionGrant(input: $input) {\n      optionGrant {\n        id\n        issuedAt\n        quantity\n        state\n        purchasePrice\n        exercisePrice\n        remarks\n        holder {\n          id\n        }\n        optionPlan {\n          id\n          draftedOptions\n        }\n      }\n    }\n  }\n"], ["\n  mutation UpdateOptionGrant($input: UpdateOptionGrantInput!) {\n    updateOptionGrant(input: $input) {\n      optionGrant {\n        id\n        issuedAt\n        quantity\n        state\n        purchasePrice\n        exercisePrice\n        remarks\n        holder {\n          id\n        }\n        optionPlan {\n          id\n          draftedOptions\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateOptionGrantMutation__
 *
 * To run a mutation, you first call `useUpdateOptionGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOptionGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOptionGrantMutation, { data, loading, error }] = useUpdateOptionGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOptionGrantMutation(baseOptions) {
    return Apollo.useMutation(UpdateOptionGrantDocument, baseOptions);
}
export var DeleteOptionGrantDocument = gql(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n  mutation DeleteOptionGrant($input: DeleteOptionGrantInput!) {\n    deleteOptionGrant(input: $input) {\n      optionGrant {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteOptionGrant($input: DeleteOptionGrantInput!) {\n    deleteOptionGrant(input: $input) {\n      optionGrant {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteOptionGrantMutation__
 *
 * To run a mutation, you first call `useDeleteOptionGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOptionGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOptionGrantMutation, { data, loading, error }] = useDeleteOptionGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteOptionGrantMutation(baseOptions) {
    return Apollo.useMutation(DeleteOptionGrantDocument, baseOptions);
}
export var CancelOptionGrantDocument = gql(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n  mutation CancelOptionGrant($input: CancelOptionGrantInput!) {\n    cancelOptionGrant(input: $input) {\n      optionGrant {\n        id\n        state\n      }\n    }\n  }\n"], ["\n  mutation CancelOptionGrant($input: CancelOptionGrantInput!) {\n    cancelOptionGrant(input: $input) {\n      optionGrant {\n        id\n        state\n      }\n    }\n  }\n"])));
/**
 * __useCancelOptionGrantMutation__
 *
 * To run a mutation, you first call `useCancelOptionGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOptionGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOptionGrantMutation, { data, loading, error }] = useCancelOptionGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelOptionGrantMutation(baseOptions) {
    return Apollo.useMutation(CancelOptionGrantDocument, baseOptions);
}
export var IssueOptionGrantDocument = gql(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n  mutation IssueOptionGrant($input: IssueOptionGrantInput!) {\n    issueOptionGrant(input: $input) {\n      optionGrant {\n        id\n        state\n      }\n    }\n  }\n"], ["\n  mutation IssueOptionGrant($input: IssueOptionGrantInput!) {\n    issueOptionGrant(input: $input) {\n      optionGrant {\n        id\n        state\n      }\n    }\n  }\n"])));
/**
 * __useIssueOptionGrantMutation__
 *
 * To run a mutation, you first call `useIssueOptionGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueOptionGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueOptionGrantMutation, { data, loading, error }] = useIssueOptionGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueOptionGrantMutation(baseOptions) {
    return Apollo.useMutation(IssueOptionGrantDocument, baseOptions);
}
export var SafesPageDocument = gql(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n  query SafesPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      safeTerms {\n        id\n        name\n        discount\n        valuationBasis\n        valuationCap\n        safes {\n          id\n          issuedAt\n          holder {\n            __typename\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          sequenceNumber\n          principal\n        }\n      }\n    }\n  }\n"], ["\n  query SafesPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      safeTerms {\n        id\n        name\n        discount\n        valuationBasis\n        valuationCap\n        safes {\n          id\n          issuedAt\n          holder {\n            __typename\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          sequenceNumber\n          principal\n        }\n      }\n    }\n  }\n"])));
/**
 * __useSafesPageQuery__
 *
 * To run a query within a React component, call `useSafesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafesPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSafesPageQuery(baseOptions) {
    return Apollo.useQuery(SafesPageDocument, baseOptions);
}
export function useSafesPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(SafesPageDocument, baseOptions);
}
export function refetchSafesPageQuery(variables) {
    return { query: SafesPageDocument, variables: variables };
}
export var UpdateSafeTermPageDocument = gql(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n  query UpdateSafeTermPage($safeTermId: ID!) {\n    safeTerm(id: $safeTermId) {\n      id\n      name\n      discount\n      organization {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query UpdateSafeTermPage($safeTermId: ID!) {\n    safeTerm(id: $safeTermId) {\n      id\n      name\n      discount\n      organization {\n        id\n        name\n      }\n    }\n  }\n"])));
/**
 * __useUpdateSafeTermPageQuery__
 *
 * To run a query within a React component, call `useUpdateSafeTermPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafeTermPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateSafeTermPageQuery({
 *   variables: {
 *      safeTermId: // value for 'safeTermId'
 *   },
 * });
 */
export function useUpdateSafeTermPageQuery(baseOptions) {
    return Apollo.useQuery(UpdateSafeTermPageDocument, baseOptions);
}
export function useUpdateSafeTermPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateSafeTermPageDocument, baseOptions);
}
export function refetchUpdateSafeTermPageQuery(variables) {
    return { query: UpdateSafeTermPageDocument, variables: variables };
}
export var SafeDetailsDocument = gql(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  query SafeDetails($safeId: ID!) {\n    safe(id: $safeId) {\n      id\n      issuedAt\n      state\n      sequenceNumber\n      principal\n      remarks\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      safeTerm {\n        id\n        name\n        valuationCap\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query SafeDetails($safeId: ID!) {\n    safe(id: $safeId) {\n      id\n      issuedAt\n      state\n      sequenceNumber\n      principal\n      remarks\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      safeTerm {\n        id\n        name\n        valuationCap\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useSafeDetailsQuery__
 *
 * To run a query within a React component, call `useSafeDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafeDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafeDetailsQuery({
 *   variables: {
 *      safeId: // value for 'safeId'
 *   },
 * });
 */
export function useSafeDetailsQuery(baseOptions) {
    return Apollo.useQuery(SafeDetailsDocument, baseOptions);
}
export function useSafeDetailsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(SafeDetailsDocument, baseOptions);
}
export function refetchSafeDetailsQuery(variables) {
    return { query: SafeDetailsDocument, variables: variables };
}
export var SafesListDocument = gql(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n  query SafesList($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      safeTerms {\n        id\n        name\n        safes {\n          id\n          principal\n          remarks\n          sequenceNumber\n          state\n          issuedAt\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n            ... on User {\n              emails {\n                verified\n              }\n            }\n          }\n          safeTerm {\n            id\n            name\n            valuationCap\n            discount\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query SafesList($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      safeTerms {\n        id\n        name\n        safes {\n          id\n          principal\n          remarks\n          sequenceNumber\n          state\n          issuedAt\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n            ... on User {\n              emails {\n                verified\n              }\n            }\n          }\n          safeTerm {\n            id\n            name\n            valuationCap\n            discount\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useSafesListQuery__
 *
 * To run a query within a React component, call `useSafesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSafesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSafesListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSafesListQuery(baseOptions) {
    return Apollo.useQuery(SafesListDocument, baseOptions);
}
export function useSafesListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(SafesListDocument, baseOptions);
}
export function refetchSafesListQuery(variables) {
    return { query: SafesListDocument, variables: variables };
}
export var UpdateSafePageDocument = gql(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n  query UpdateSafePage($safeId: ID!) {\n    safe(id: $safeId) {\n      id\n      issuedAt\n      state\n      sequenceNumber\n      principal\n      remarks\n      holder {\n        id\n        name\n      }\n      safeTerm {\n        id\n        name\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query UpdateSafePage($safeId: ID!) {\n    safe(id: $safeId) {\n      id\n      issuedAt\n      state\n      sequenceNumber\n      principal\n      remarks\n      holder {\n        id\n        name\n      }\n      safeTerm {\n        id\n        name\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateSafePageQuery__
 *
 * To run a query within a React component, call `useUpdateSafePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateSafePageQuery({
 *   variables: {
 *      safeId: // value for 'safeId'
 *   },
 * });
 */
export function useUpdateSafePageQuery(baseOptions) {
    return Apollo.useQuery(UpdateSafePageDocument, baseOptions);
}
export function useUpdateSafePageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateSafePageDocument, baseOptions);
}
export function refetchUpdateSafePageQuery(variables) {
    return { query: UpdateSafePageDocument, variables: variables };
}
export var CreateSafeTermDocument = gql(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n  mutation CreateSafeTerm($input: CreateSafeTermInput!) {\n    createSafeTerm(input: $input) {\n      safeTerm {\n        id\n        name\n        discount\n        valuationBasis\n        valuationCap\n        safes {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateSafeTerm($input: CreateSafeTermInput!) {\n    createSafeTerm(input: $input) {\n      safeTerm {\n        id\n        name\n        discount\n        valuationBasis\n        valuationCap\n        safes {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateSafeTermMutation__
 *
 * To run a mutation, you first call `useCreateSafeTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSafeTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSafeTermMutation, { data, loading, error }] = useCreateSafeTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSafeTermMutation(baseOptions) {
    return Apollo.useMutation(CreateSafeTermDocument, baseOptions);
}
export var UpdateSafeTermDocument = gql(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n  mutation UpdateSafeTerm($input: UpdateSafeTermInput!) {\n    updateSafeTerm(input: $input) {\n      safeTerm {\n        id\n        name\n        discount\n      }\n    }\n  }\n"], ["\n  mutation UpdateSafeTerm($input: UpdateSafeTermInput!) {\n    updateSafeTerm(input: $input) {\n      safeTerm {\n        id\n        name\n        discount\n      }\n    }\n  }\n"])));
/**
 * __useUpdateSafeTermMutation__
 *
 * To run a mutation, you first call `useUpdateSafeTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafeTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafeTermMutation, { data, loading, error }] = useUpdateSafeTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafeTermMutation(baseOptions) {
    return Apollo.useMutation(UpdateSafeTermDocument, baseOptions);
}
export var DeleteSafeTermDocument = gql(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n  mutation DeleteSafeTerm($input: DeleteSafeTermInput!) {\n    deleteSafeTerm(input: $input) {\n      safeTerm {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteSafeTerm($input: DeleteSafeTermInput!) {\n    deleteSafeTerm(input: $input) {\n      safeTerm {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteSafeTermMutation__
 *
 * To run a mutation, you first call `useDeleteSafeTermMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSafeTermMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSafeTermMutation, { data, loading, error }] = useDeleteSafeTermMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSafeTermMutation(baseOptions) {
    return Apollo.useMutation(DeleteSafeTermDocument, baseOptions);
}
export var CreateSafeCertificateDocument = gql(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n  mutation CreateSafeCertificate($input: CreateSafeInput!) {\n    createSafe(input: $input) {\n      safe {\n        id\n      }\n    }\n  }\n"], ["\n  mutation CreateSafeCertificate($input: CreateSafeInput!) {\n    createSafe(input: $input) {\n      safe {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateSafeCertificateMutation__
 *
 * To run a mutation, you first call `useCreateSafeCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSafeCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSafeCertificateMutation, { data, loading, error }] = useCreateSafeCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSafeCertificateMutation(baseOptions) {
    return Apollo.useMutation(CreateSafeCertificateDocument, baseOptions);
}
export var UpdateSafeCertificateDocument = gql(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n  mutation UpdateSafeCertificate($input: UpdateSafeInput!) {\n    updateSafe(input: $input) {\n      safe {\n        id\n        issuedAt\n        sequenceNumber\n        principal\n        remarks\n        holder {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation UpdateSafeCertificate($input: UpdateSafeInput!) {\n    updateSafe(input: $input) {\n      safe {\n        id\n        issuedAt\n        sequenceNumber\n        principal\n        remarks\n        holder {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateSafeCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateSafeCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSafeCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSafeCertificateMutation, { data, loading, error }] = useUpdateSafeCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSafeCertificateMutation(baseOptions) {
    return Apollo.useMutation(UpdateSafeCertificateDocument, baseOptions);
}
export var DeleteSafeCertificateDocument = gql(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n  mutation DeleteSafeCertificate($input: DeleteSafeInput!) {\n    deleteSafe(input: $input) {\n      safe {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteSafeCertificate($input: DeleteSafeInput!) {\n    deleteSafe(input: $input) {\n      safe {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteSafeCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteSafeCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSafeCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSafeCertificateMutation, { data, loading, error }] = useDeleteSafeCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteSafeCertificateMutation(baseOptions) {
    return Apollo.useMutation(DeleteSafeCertificateDocument, baseOptions);
}
export var CancelSafeCertificateDocument = gql(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n  mutation CancelSafeCertificate($input: CancelSafeInput!) {\n    cancelSafe(input: $input) {\n      safe {\n        id\n        state\n      }\n    }\n  }\n"], ["\n  mutation CancelSafeCertificate($input: CancelSafeInput!) {\n    cancelSafe(input: $input) {\n      safe {\n        id\n        state\n      }\n    }\n  }\n"])));
/**
 * __useCancelSafeCertificateMutation__
 *
 * To run a mutation, you first call `useCancelSafeCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSafeCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSafeCertificateMutation, { data, loading, error }] = useCancelSafeCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelSafeCertificateMutation(baseOptions) {
    return Apollo.useMutation(CancelSafeCertificateDocument, baseOptions);
}
export var IssueSafeCertificateDocument = gql(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n  mutation IssueSafeCertificate($input: IssueSafeInput!) {\n    issueSafe(input: $input) {\n      safe {\n        id\n        state\n      }\n    }\n  }\n"], ["\n  mutation IssueSafeCertificate($input: IssueSafeInput!) {\n    issueSafe(input: $input) {\n      safe {\n        id\n        state\n      }\n    }\n  }\n"])));
/**
 * __useIssueSafeCertificateMutation__
 *
 * To run a mutation, you first call `useIssueSafeCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueSafeCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueSafeCertificateMutation, { data, loading, error }] = useIssueSafeCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueSafeCertificateMutation(baseOptions) {
    return Apollo.useMutation(IssueSafeCertificateDocument, baseOptions);
}
export var SharesPageDocument = gql(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n  query SharesPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      shareClasses {\n        id\n        name\n        type\n        nominalValue\n        authorizedShares\n        draftedShares\n        issuedShares\n        optionPoolShares\n        shareCertificates {\n          id\n          state\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          sequenceNumber\n          quantity\n        }\n        warrantBlocks {\n          id\n        }\n        optionPlans {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  query SharesPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      shareClasses {\n        id\n        name\n        type\n        nominalValue\n        authorizedShares\n        draftedShares\n        issuedShares\n        optionPoolShares\n        shareCertificates {\n          id\n          state\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          sequenceNumber\n          quantity\n        }\n        warrantBlocks {\n          id\n        }\n        optionPlans {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useSharesPageQuery__
 *
 * To run a query within a React component, call `useSharesPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharesPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharesPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSharesPageQuery(baseOptions) {
    return Apollo.useQuery(SharesPageDocument, baseOptions);
}
export function useSharesPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(SharesPageDocument, baseOptions);
}
export function refetchSharesPageQuery(variables) {
    return { query: SharesPageDocument, variables: variables };
}
export var ShareClassesListDocument = gql(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n  query ShareClassesList($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      shareClasses {\n        id\n        name\n        type\n        nominalValue\n        authorizedShares\n        draftedShares\n        issuedShares\n        optionPoolShares\n        optionPlans {\n          id\n          name\n          planSize\n          issuedOptions\n          shareClass {\n            id\n            name\n          }\n        }\n        warrantBlocks {\n          id\n          name\n          issuedWarrants\n        }\n      }\n    }\n  }\n"], ["\n  query ShareClassesList($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      shareClasses {\n        id\n        name\n        type\n        nominalValue\n        authorizedShares\n        draftedShares\n        issuedShares\n        optionPoolShares\n        optionPlans {\n          id\n          name\n          planSize\n          issuedOptions\n          shareClass {\n            id\n            name\n          }\n        }\n        warrantBlocks {\n          id\n          name\n          issuedWarrants\n        }\n      }\n    }\n  }\n"])));
/**
 * __useShareClassesListQuery__
 *
 * To run a query within a React component, call `useShareClassesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareClassesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareClassesListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useShareClassesListQuery(baseOptions) {
    return Apollo.useQuery(ShareClassesListDocument, baseOptions);
}
export function useShareClassesListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(ShareClassesListDocument, baseOptions);
}
export function refetchShareClassesListQuery(variables) {
    return { query: ShareClassesListDocument, variables: variables };
}
export var ShareCertificateDetailsDocument = gql(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n  query ShareCertificateDetails($shareCertificateId: ID!) {\n    shareCertificate(id: $shareCertificateId) {\n      id\n      issuedAt\n      quantity\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      state\n      sequenceNumber\n      amountPaid\n      remarks\n      shareClass {\n        id\n        name\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query ShareCertificateDetails($shareCertificateId: ID!) {\n    shareCertificate(id: $shareCertificateId) {\n      id\n      issuedAt\n      quantity\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      state\n      sequenceNumber\n      amountPaid\n      remarks\n      shareClass {\n        id\n        name\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useShareCertificateDetailsQuery__
 *
 * To run a query within a React component, call `useShareCertificateDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareCertificateDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareCertificateDetailsQuery({
 *   variables: {
 *      shareCertificateId: // value for 'shareCertificateId'
 *   },
 * });
 */
export function useShareCertificateDetailsQuery(baseOptions) {
    return Apollo.useQuery(ShareCertificateDetailsDocument, baseOptions);
}
export function useShareCertificateDetailsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(ShareCertificateDetailsDocument, baseOptions);
}
export function refetchShareCertificateDetailsQuery(variables) {
    return { query: ShareCertificateDetailsDocument, variables: variables };
}
export var ShareCertificatesListDocument = gql(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n  query ShareCertificatesList($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      shareClasses {\n        id\n        name\n        nominalValue\n        authorizedShares\n        draftedShares\n        issuedShares\n        optionPoolShares\n        shareCertificates {\n          id\n          issuedAt\n          quantity\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          sequenceNumber\n          amountPaid\n          shareClass {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query ShareCertificatesList($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      shareClasses {\n        id\n        name\n        nominalValue\n        authorizedShares\n        draftedShares\n        issuedShares\n        optionPoolShares\n        shareCertificates {\n          id\n          issuedAt\n          quantity\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          sequenceNumber\n          amountPaid\n          shareClass {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useShareCertificatesListQuery__
 *
 * To run a query within a React component, call `useShareCertificatesListQuery` and pass it any options that fit your needs.
 * When your component renders, `useShareCertificatesListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShareCertificatesListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useShareCertificatesListQuery(baseOptions) {
    return Apollo.useQuery(ShareCertificatesListDocument, baseOptions);
}
export function useShareCertificatesListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(ShareCertificatesListDocument, baseOptions);
}
export function refetchShareCertificatesListQuery(variables) {
    return { query: ShareCertificatesListDocument, variables: variables };
}
export var UpdateShareClassPageDocument = gql(templateObject_61 || (templateObject_61 = __makeTemplateObject(["\n  query UpdateShareClassPage($shareClassId: ID!) {\n    shareClass(id: $shareClassId) {\n      id\n      name\n      type\n      authorizedShares\n      nominalValue\n      organization {\n        id\n        name\n      }\n    }\n  }\n"], ["\n  query UpdateShareClassPage($shareClassId: ID!) {\n    shareClass(id: $shareClassId) {\n      id\n      name\n      type\n      authorizedShares\n      nominalValue\n      organization {\n        id\n        name\n      }\n    }\n  }\n"])));
/**
 * __useUpdateShareClassPageQuery__
 *
 * To run a query within a React component, call `useUpdateShareClassPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareClassPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateShareClassPageQuery({
 *   variables: {
 *      shareClassId: // value for 'shareClassId'
 *   },
 * });
 */
export function useUpdateShareClassPageQuery(baseOptions) {
    return Apollo.useQuery(UpdateShareClassPageDocument, baseOptions);
}
export function useUpdateShareClassPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateShareClassPageDocument, baseOptions);
}
export function refetchUpdateShareClassPageQuery(variables) {
    return { query: UpdateShareClassPageDocument, variables: variables };
}
export var UpdateShareCertificatePageDocument = gql(templateObject_62 || (templateObject_62 = __makeTemplateObject(["\n  query UpdateShareCertificatePage($shareCertificateId: ID!) {\n    shareCertificate(id: $shareCertificateId) {\n      id\n      issuedAt\n      quantity\n      holder {\n        id\n        name\n      }\n      state\n      sequenceNumber\n      amountPaid\n      remarks\n      shareClass {\n        id\n        name\n        nominalValue\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query UpdateShareCertificatePage($shareCertificateId: ID!) {\n    shareCertificate(id: $shareCertificateId) {\n      id\n      issuedAt\n      quantity\n      holder {\n        id\n        name\n      }\n      state\n      sequenceNumber\n      amountPaid\n      remarks\n      shareClass {\n        id\n        name\n        nominalValue\n        organization {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateShareCertificatePageQuery__
 *
 * To run a query within a React component, call `useUpdateShareCertificatePageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareCertificatePageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateShareCertificatePageQuery({
 *   variables: {
 *      shareCertificateId: // value for 'shareCertificateId'
 *   },
 * });
 */
export function useUpdateShareCertificatePageQuery(baseOptions) {
    return Apollo.useQuery(UpdateShareCertificatePageDocument, baseOptions);
}
export function useUpdateShareCertificatePageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateShareCertificatePageDocument, baseOptions);
}
export function refetchUpdateShareCertificatePageQuery(variables) {
    return { query: UpdateShareCertificatePageDocument, variables: variables };
}
export var CreateShareClassDocument = gql(templateObject_63 || (templateObject_63 = __makeTemplateObject(["\n  mutation CreateShareClass($input: CreateShareClassInput!) {\n    createShareClass(input: $input) {\n      shareClass {\n        id\n        name\n        type\n        authorizedShares\n        nominalValue\n        shareCertificates {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateShareClass($input: CreateShareClassInput!) {\n    createShareClass(input: $input) {\n      shareClass {\n        id\n        name\n        type\n        authorizedShares\n        nominalValue\n        shareCertificates {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateShareClassMutation__
 *
 * To run a mutation, you first call `useCreateShareClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareClassMutation, { data, loading, error }] = useCreateShareClassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShareClassMutation(baseOptions) {
    return Apollo.useMutation(CreateShareClassDocument, baseOptions);
}
export var UpdateShareClassDocument = gql(templateObject_64 || (templateObject_64 = __makeTemplateObject(["\n  mutation UpdateShareClass($input: UpdateShareClassInput!) {\n    updateShareClass(input: $input) {\n      shareClass {\n        id\n        name\n        type\n        nominalValue\n      }\n    }\n  }\n"], ["\n  mutation UpdateShareClass($input: UpdateShareClassInput!) {\n    updateShareClass(input: $input) {\n      shareClass {\n        id\n        name\n        type\n        nominalValue\n      }\n    }\n  }\n"])));
/**
 * __useUpdateShareClassMutation__
 *
 * To run a mutation, you first call `useUpdateShareClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareClassMutation, { data, loading, error }] = useUpdateShareClassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShareClassMutation(baseOptions) {
    return Apollo.useMutation(UpdateShareClassDocument, baseOptions);
}
export var DeleteShareClassDocument = gql(templateObject_65 || (templateObject_65 = __makeTemplateObject(["\n  mutation DeleteShareClass($input: DeleteShareClassInput!) {\n    deleteShareClass(input: $input) {\n      shareClass {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteShareClass($input: DeleteShareClassInput!) {\n    deleteShareClass(input: $input) {\n      shareClass {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteShareClassMutation__
 *
 * To run a mutation, you first call `useDeleteShareClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShareClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShareClassMutation, { data, loading, error }] = useDeleteShareClassMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShareClassMutation(baseOptions) {
    return Apollo.useMutation(DeleteShareClassDocument, baseOptions);
}
export var CreateShareCertificateDocument = gql(templateObject_66 || (templateObject_66 = __makeTemplateObject(["\n  mutation CreateShareCertificate($input: CreateShareCertificateInput!) {\n    createShareCertificate(input: $input) {\n      shareCertificate {\n        id\n      }\n    }\n  }\n"], ["\n  mutation CreateShareCertificate($input: CreateShareCertificateInput!) {\n    createShareCertificate(input: $input) {\n      shareCertificate {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateShareCertificateMutation__
 *
 * To run a mutation, you first call `useCreateShareCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateShareCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createShareCertificateMutation, { data, loading, error }] = useCreateShareCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateShareCertificateMutation(baseOptions) {
    return Apollo.useMutation(CreateShareCertificateDocument, baseOptions);
}
export var UpdateShareCertificateDocument = gql(templateObject_67 || (templateObject_67 = __makeTemplateObject(["\n  mutation UpdateShareCertificate($input: UpdateShareCertificateInput!) {\n    updateShareCertificate(input: $input) {\n      shareCertificate {\n        id\n        issuedAt\n        sequenceNumber\n        state\n        quantity\n        amountPaid\n        remarks\n        holder {\n          id\n        }\n        shareClass {\n          id\n          authorizedShares\n          draftedShares\n          issuedShares\n          optionPoolShares\n        }\n      }\n    }\n  }\n"], ["\n  mutation UpdateShareCertificate($input: UpdateShareCertificateInput!) {\n    updateShareCertificate(input: $input) {\n      shareCertificate {\n        id\n        issuedAt\n        sequenceNumber\n        state\n        quantity\n        amountPaid\n        remarks\n        holder {\n          id\n        }\n        shareClass {\n          id\n          authorizedShares\n          draftedShares\n          issuedShares\n          optionPoolShares\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateShareCertificateMutation__
 *
 * To run a mutation, you first call `useUpdateShareCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateShareCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateShareCertificateMutation, { data, loading, error }] = useUpdateShareCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateShareCertificateMutation(baseOptions) {
    return Apollo.useMutation(UpdateShareCertificateDocument, baseOptions);
}
export var DeleteShareCertificateDocument = gql(templateObject_68 || (templateObject_68 = __makeTemplateObject(["\n  mutation DeleteShareCertificate($input: DeleteShareCertificateInput!) {\n    deleteShareCertificate(input: $input) {\n      shareCertificate {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteShareCertificate($input: DeleteShareCertificateInput!) {\n    deleteShareCertificate(input: $input) {\n      shareCertificate {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteShareCertificateMutation__
 *
 * To run a mutation, you first call `useDeleteShareCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteShareCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteShareCertificateMutation, { data, loading, error }] = useDeleteShareCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteShareCertificateMutation(baseOptions) {
    return Apollo.useMutation(DeleteShareCertificateDocument, baseOptions);
}
export var CancelShareCertificateDocument = gql(templateObject_69 || (templateObject_69 = __makeTemplateObject(["\n  mutation CancelShareCertificate($input: CancelShareCertificateInput!) {\n    cancelShareCertificate(input: $input) {\n      shareCertificate {\n        id\n        state\n        shareClass {\n          id\n          authorizedShares\n          draftedShares\n          issuedShares\n          optionPoolShares\n        }\n      }\n    }\n  }\n"], ["\n  mutation CancelShareCertificate($input: CancelShareCertificateInput!) {\n    cancelShareCertificate(input: $input) {\n      shareCertificate {\n        id\n        state\n        shareClass {\n          id\n          authorizedShares\n          draftedShares\n          issuedShares\n          optionPoolShares\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCancelShareCertificateMutation__
 *
 * To run a mutation, you first call `useCancelShareCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelShareCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelShareCertificateMutation, { data, loading, error }] = useCancelShareCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelShareCertificateMutation(baseOptions) {
    return Apollo.useMutation(CancelShareCertificateDocument, baseOptions);
}
export var IssueShareCertificateDocument = gql(templateObject_70 || (templateObject_70 = __makeTemplateObject(["\n  mutation IssueShareCertificate($input: IssueShareCertificateInput!) {\n    issueShareCertificate(input: $input) {\n      shareCertificate {\n        id\n        state\n        shareClass {\n          id\n          authorizedShares\n          draftedShares\n          issuedShares\n          optionPoolShares\n        }\n      }\n    }\n  }\n"], ["\n  mutation IssueShareCertificate($input: IssueShareCertificateInput!) {\n    issueShareCertificate(input: $input) {\n      shareCertificate {\n        id\n        state\n        shareClass {\n          id\n          authorizedShares\n          draftedShares\n          issuedShares\n          optionPoolShares\n        }\n      }\n    }\n  }\n"])));
/**
 * __useIssueShareCertificateMutation__
 *
 * To run a mutation, you first call `useIssueShareCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueShareCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueShareCertificateMutation, { data, loading, error }] = useIssueShareCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueShareCertificateMutation(baseOptions) {
    return Apollo.useMutation(IssueShareCertificateDocument, baseOptions);
}
export var WarrantsPageDocument = gql(templateObject_71 || (templateObject_71 = __makeTemplateObject(["\n  query WarrantsPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      shareClasses {\n        id\n        name\n      }\n      warrantBlocks {\n        id\n        shareClass {\n          id\n          name\n        }\n        name\n        exercisePrice\n        issuedWarrants\n        warrantGrants {\n          id\n          issuedAt\n          expiresOn\n          holder {\n            __typename\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          quantity\n          exercisePrice\n        }\n      }\n    }\n  }\n"], ["\n  query WarrantsPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      shareClasses {\n        id\n        name\n      }\n      warrantBlocks {\n        id\n        shareClass {\n          id\n          name\n        }\n        name\n        exercisePrice\n        issuedWarrants\n        warrantGrants {\n          id\n          issuedAt\n          expiresOn\n          holder {\n            __typename\n            id\n            name\n            ... on Ghost {\n              email\n            }\n          }\n          state\n          quantity\n          exercisePrice\n        }\n      }\n    }\n  }\n"])));
/**
 * __useWarrantsPageQuery__
 *
 * To run a query within a React component, call `useWarrantsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarrantsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarrantsPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWarrantsPageQuery(baseOptions) {
    return Apollo.useQuery(WarrantsPageDocument, baseOptions);
}
export function useWarrantsPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(WarrantsPageDocument, baseOptions);
}
export function refetchWarrantsPageQuery(variables) {
    return { query: WarrantsPageDocument, variables: variables };
}
export var WarrantBlocksPageDocument = gql(templateObject_72 || (templateObject_72 = __makeTemplateObject(["\n  query WarrantBlocksPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      warrantBlocks {\n        id\n        name\n      }\n      shareClasses {\n        id\n        name\n        warrantBlocks {\n          id\n          name\n          exercisePrice\n          issuedWarrants\n          shareClass {\n            id\n            name\n          }\n          warrantGrants {\n            id\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query WarrantBlocksPage($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      warrantBlocks {\n        id\n        name\n      }\n      shareClasses {\n        id\n        name\n        warrantBlocks {\n          id\n          name\n          exercisePrice\n          issuedWarrants\n          shareClass {\n            id\n            name\n          }\n          warrantGrants {\n            id\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useWarrantBlocksPageQuery__
 *
 * To run a query within a React component, call `useWarrantBlocksPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarrantBlocksPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarrantBlocksPageQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWarrantBlocksPageQuery(baseOptions) {
    return Apollo.useQuery(WarrantBlocksPageDocument, baseOptions);
}
export function useWarrantBlocksPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(WarrantBlocksPageDocument, baseOptions);
}
export function refetchWarrantBlocksPageQuery(variables) {
    return { query: WarrantBlocksPageDocument, variables: variables };
}
export var UpdateWarrantBlockPageDocument = gql(templateObject_73 || (templateObject_73 = __makeTemplateObject(["\n  query UpdateWarrantBlockPage($warrantBlockId: ID!) {\n    warrantBlock(id: $warrantBlockId) {\n      name\n      exercisePrice\n      shareClass {\n        id\n        name\n        organization {\n          id\n          name\n          shareClasses {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query UpdateWarrantBlockPage($warrantBlockId: ID!) {\n    warrantBlock(id: $warrantBlockId) {\n      name\n      exercisePrice\n      shareClass {\n        id\n        name\n        organization {\n          id\n          name\n          shareClasses {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateWarrantBlockPageQuery__
 *
 * To run a query within a React component, call `useUpdateWarrantBlockPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarrantBlockPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateWarrantBlockPageQuery({
 *   variables: {
 *      warrantBlockId: // value for 'warrantBlockId'
 *   },
 * });
 */
export function useUpdateWarrantBlockPageQuery(baseOptions) {
    return Apollo.useQuery(UpdateWarrantBlockPageDocument, baseOptions);
}
export function useUpdateWarrantBlockPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateWarrantBlockPageDocument, baseOptions);
}
export function refetchUpdateWarrantBlockPageQuery(variables) {
    return { query: UpdateWarrantBlockPageDocument, variables: variables };
}
export var WarrantGrantDetailsDocument = gql(templateObject_74 || (templateObject_74 = __makeTemplateObject(["\n  query WarrantGrantDetails($warrantGrantId: ID!) {\n    warrantGrant(id: $warrantGrantId) {\n      id\n      issuedAt\n      expiresOn\n      remarks\n      warrantBlock {\n        id\n        name\n        shareClass {\n          id\n          organization {\n            id\n            name\n          }\n        }\n      }\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      state\n      quantity\n      exercisePrice\n    }\n  }\n"], ["\n  query WarrantGrantDetails($warrantGrantId: ID!) {\n    warrantGrant(id: $warrantGrantId) {\n      id\n      issuedAt\n      expiresOn\n      remarks\n      warrantBlock {\n        id\n        name\n        shareClass {\n          id\n          organization {\n            id\n            name\n          }\n        }\n      }\n      holder {\n        id\n        name\n        ... on Ghost {\n          email\n        }\n        ... on User {\n          emails {\n            verified\n          }\n        }\n      }\n      state\n      quantity\n      exercisePrice\n    }\n  }\n"])));
/**
 * __useWarrantGrantDetailsQuery__
 *
 * To run a query within a React component, call `useWarrantGrantDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarrantGrantDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarrantGrantDetailsQuery({
 *   variables: {
 *      warrantGrantId: // value for 'warrantGrantId'
 *   },
 * });
 */
export function useWarrantGrantDetailsQuery(baseOptions) {
    return Apollo.useQuery(WarrantGrantDetailsDocument, baseOptions);
}
export function useWarrantGrantDetailsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(WarrantGrantDetailsDocument, baseOptions);
}
export function refetchWarrantGrantDetailsQuery(variables) {
    return { query: WarrantGrantDetailsDocument, variables: variables };
}
export var WarrantGrantsListDocument = gql(templateObject_75 || (templateObject_75 = __makeTemplateObject(["\n  query WarrantGrantsList($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      shareClasses {\n        id\n        name\n        warrantBlocks {\n          id\n          name\n          exercisePrice\n          shareClass {\n            id\n            name\n          }\n          warrantGrants {\n            id\n          }\n        }\n      }\n      warrantBlocks {\n        id\n        name\n        exercisePrice\n        shareClass {\n          id\n          name\n        }\n        warrantGrants {\n          id\n          issuedAt\n          expiresOn\n          remarks\n          warrantBlock {\n            id\n            name\n          }\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n            ... on User {\n              emails {\n                verified\n              }\n            }\n          }\n          state\n          quantity\n          exercisePrice\n        }\n      }\n    }\n  }\n"], ["\n  query WarrantGrantsList($organizationId: ID!) {\n    organization(id: $organizationId) {\n      id\n      name\n      shareClasses {\n        id\n        name\n        warrantBlocks {\n          id\n          name\n          exercisePrice\n          shareClass {\n            id\n            name\n          }\n          warrantGrants {\n            id\n          }\n        }\n      }\n      warrantBlocks {\n        id\n        name\n        exercisePrice\n        shareClass {\n          id\n          name\n        }\n        warrantGrants {\n          id\n          issuedAt\n          expiresOn\n          remarks\n          warrantBlock {\n            id\n            name\n          }\n          holder {\n            id\n            name\n            ... on Ghost {\n              email\n            }\n            ... on User {\n              emails {\n                verified\n              }\n            }\n          }\n          state\n          quantity\n          exercisePrice\n        }\n      }\n    }\n  }\n"])));
/**
 * __useWarrantGrantsListQuery__
 *
 * To run a query within a React component, call `useWarrantGrantsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWarrantGrantsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWarrantGrantsListQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useWarrantGrantsListQuery(baseOptions) {
    return Apollo.useQuery(WarrantGrantsListDocument, baseOptions);
}
export function useWarrantGrantsListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(WarrantGrantsListDocument, baseOptions);
}
export function refetchWarrantGrantsListQuery(variables) {
    return { query: WarrantGrantsListDocument, variables: variables };
}
export var UpdateWarrantGrantPageDocument = gql(templateObject_76 || (templateObject_76 = __makeTemplateObject(["\n  query UpdateWarrantGrantPage($warrantGrantId: ID!) {\n    warrantGrant(id: $warrantGrantId) {\n      id\n      issuedAt\n      expiresOn\n      quantity\n      state\n      exercisePrice\n      remarks\n      holder {\n        id\n        name\n      }\n      warrantBlock {\n        id\n        shareClass {\n          id\n          name\n          organization {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"], ["\n  query UpdateWarrantGrantPage($warrantGrantId: ID!) {\n    warrantGrant(id: $warrantGrantId) {\n      id\n      issuedAt\n      expiresOn\n      quantity\n      state\n      exercisePrice\n      remarks\n      holder {\n        id\n        name\n      }\n      warrantBlock {\n        id\n        shareClass {\n          id\n          name\n          organization {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateWarrantGrantPageQuery__
 *
 * To run a query within a React component, call `useUpdateWarrantGrantPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarrantGrantPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateWarrantGrantPageQuery({
 *   variables: {
 *      warrantGrantId: // value for 'warrantGrantId'
 *   },
 * });
 */
export function useUpdateWarrantGrantPageQuery(baseOptions) {
    return Apollo.useQuery(UpdateWarrantGrantPageDocument, baseOptions);
}
export function useUpdateWarrantGrantPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateWarrantGrantPageDocument, baseOptions);
}
export function refetchUpdateWarrantGrantPageQuery(variables) {
    return { query: UpdateWarrantGrantPageDocument, variables: variables };
}
export var CreateWarrantBlockDocument = gql(templateObject_77 || (templateObject_77 = __makeTemplateObject(["\n  mutation CreateWarrantBlock($input: CreateWarrantBlockInput!) {\n    createWarrantBlock(input: $input) {\n      warrantBlock {\n        id\n        name\n        shareClass {\n          id\n          name\n        }\n        exercisePrice\n        warrantGrants {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation CreateWarrantBlock($input: CreateWarrantBlockInput!) {\n    createWarrantBlock(input: $input) {\n      warrantBlock {\n        id\n        name\n        shareClass {\n          id\n          name\n        }\n        exercisePrice\n        warrantGrants {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useCreateWarrantBlockMutation__
 *
 * To run a mutation, you first call `useCreateWarrantBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarrantBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarrantBlockMutation, { data, loading, error }] = useCreateWarrantBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWarrantBlockMutation(baseOptions) {
    return Apollo.useMutation(CreateWarrantBlockDocument, baseOptions);
}
export var UpdateWarrantBlockDocument = gql(templateObject_78 || (templateObject_78 = __makeTemplateObject(["\n  mutation UpdateWarrantBlock($input: UpdateWarrantBlockInput!) {\n    updateWarrantBlock(input: $input) {\n      warrantBlock {\n        id\n        shareClass {\n          id\n        }\n        name\n        exercisePrice\n      }\n    }\n  }\n"], ["\n  mutation UpdateWarrantBlock($input: UpdateWarrantBlockInput!) {\n    updateWarrantBlock(input: $input) {\n      warrantBlock {\n        id\n        shareClass {\n          id\n        }\n        name\n        exercisePrice\n      }\n    }\n  }\n"])));
/**
 * __useUpdateWarrantBlockMutation__
 *
 * To run a mutation, you first call `useUpdateWarrantBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarrantBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarrantBlockMutation, { data, loading, error }] = useUpdateWarrantBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWarrantBlockMutation(baseOptions) {
    return Apollo.useMutation(UpdateWarrantBlockDocument, baseOptions);
}
export var DeleteWarrantBlockDocument = gql(templateObject_79 || (templateObject_79 = __makeTemplateObject(["\n  mutation DeleteWarrantBlock($input: DeleteWarrantBlockInput!) {\n    deleteWarrantBlock(input: $input) {\n      warrantBlock {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteWarrantBlock($input: DeleteWarrantBlockInput!) {\n    deleteWarrantBlock(input: $input) {\n      warrantBlock {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteWarrantBlockMutation__
 *
 * To run a mutation, you first call `useDeleteWarrantBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWarrantBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWarrantBlockMutation, { data, loading, error }] = useDeleteWarrantBlockMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWarrantBlockMutation(baseOptions) {
    return Apollo.useMutation(DeleteWarrantBlockDocument, baseOptions);
}
export var CreateWarrantGrantDocument = gql(templateObject_80 || (templateObject_80 = __makeTemplateObject(["\n  mutation CreateWarrantGrant($input: CreateWarrantGrantInput!) {\n    createWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n      }\n    }\n  }\n"], ["\n  mutation CreateWarrantGrant($input: CreateWarrantGrantInput!) {\n    createWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useCreateWarrantGrantMutation__
 *
 * To run a mutation, you first call `useCreateWarrantGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWarrantGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWarrantGrantMutation, { data, loading, error }] = useCreateWarrantGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWarrantGrantMutation(baseOptions) {
    return Apollo.useMutation(CreateWarrantGrantDocument, baseOptions);
}
export var UpdateWarrantGrantDocument = gql(templateObject_81 || (templateObject_81 = __makeTemplateObject(["\n  mutation UpdateWarrantGrant($input: UpdateWarrantGrantInput!) {\n    updateWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n        issuedAt\n        expiresOn\n        quantity\n        state\n        exercisePrice\n        remarks\n        holder {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation UpdateWarrantGrant($input: UpdateWarrantGrantInput!) {\n    updateWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n        issuedAt\n        expiresOn\n        quantity\n        state\n        exercisePrice\n        remarks\n        holder {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useUpdateWarrantGrantMutation__
 *
 * To run a mutation, you first call `useUpdateWarrantGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarrantGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarrantGrantMutation, { data, loading, error }] = useUpdateWarrantGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWarrantGrantMutation(baseOptions) {
    return Apollo.useMutation(UpdateWarrantGrantDocument, baseOptions);
}
export var DeleteWarrantGrantDocument = gql(templateObject_82 || (templateObject_82 = __makeTemplateObject(["\n  mutation DeleteWarrantGrant($input: DeleteWarrantGrantInput!) {\n    deleteWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n      }\n    }\n  }\n"], ["\n  mutation DeleteWarrantGrant($input: DeleteWarrantGrantInput!) {\n    deleteWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n      }\n    }\n  }\n"])));
/**
 * __useDeleteWarrantGrantMutation__
 *
 * To run a mutation, you first call `useDeleteWarrantGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWarrantGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWarrantGrantMutation, { data, loading, error }] = useDeleteWarrantGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteWarrantGrantMutation(baseOptions) {
    return Apollo.useMutation(DeleteWarrantGrantDocument, baseOptions);
}
export var CancelWarrantGrantDocument = gql(templateObject_83 || (templateObject_83 = __makeTemplateObject(["\n  mutation CancelWarrantGrant($input: CancelWarrantGrantInput!) {\n    cancelWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n        state\n      }\n    }\n  }\n"], ["\n  mutation CancelWarrantGrant($input: CancelWarrantGrantInput!) {\n    cancelWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n        state\n      }\n    }\n  }\n"])));
/**
 * __useCancelWarrantGrantMutation__
 *
 * To run a mutation, you first call `useCancelWarrantGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelWarrantGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelWarrantGrantMutation, { data, loading, error }] = useCancelWarrantGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelWarrantGrantMutation(baseOptions) {
    return Apollo.useMutation(CancelWarrantGrantDocument, baseOptions);
}
export var IssueWarrantGrantDocument = gql(templateObject_84 || (templateObject_84 = __makeTemplateObject(["\n  mutation IssueWarrantGrant($input: IssueWarrantGrantInput!) {\n    issueWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n        state\n      }\n    }\n  }\n"], ["\n  mutation IssueWarrantGrant($input: IssueWarrantGrantInput!) {\n    issueWarrantGrant(input: $input) {\n      warrantGrant {\n        id\n        state\n      }\n    }\n  }\n"])));
/**
 * __useIssueWarrantGrantMutation__
 *
 * To run a mutation, you first call `useIssueWarrantGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useIssueWarrantGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [issueWarrantGrantMutation, { data, loading, error }] = useIssueWarrantGrantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useIssueWarrantGrantMutation(baseOptions) {
    return Apollo.useMutation(IssueWarrantGrantDocument, baseOptions);
}
export var SnackbarDocument = gql(templateObject_85 || (templateObject_85 = __makeTemplateObject(["\n  query Snackbar {\n    snackbarIsOpen @client\n    snackbarText @client\n  }\n"], ["\n  query Snackbar {\n    snackbarIsOpen @client\n    snackbarText @client\n  }\n"])));
/**
 * __useSnackbarQuery__
 *
 * To run a query within a React component, call `useSnackbarQuery` and pass it any options that fit your needs.
 * When your component renders, `useSnackbarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSnackbarQuery({
 *   variables: {
 *   },
 * });
 */
export function useSnackbarQuery(baseOptions) {
    return Apollo.useQuery(SnackbarDocument, baseOptions);
}
export function useSnackbarLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(SnackbarDocument, baseOptions);
}
export function refetchSnackbarQuery(variables) {
    return { query: SnackbarDocument, variables: variables };
}
export var ContentDetailsDocument = gql(templateObject_86 || (templateObject_86 = __makeTemplateObject(["\n  query ContentDetails($id: ID!) {\n    content(id: $id) {\n      id\n      title\n      description\n      type\n      previewUrl\n      imageUrl\n      ... on Content {\n        url\n        public\n        label\n        createdBy {\n          id\n          name\n        }\n        event {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query ContentDetails($id: ID!) {\n    content(id: $id) {\n      id\n      title\n      description\n      type\n      previewUrl\n      imageUrl\n      ... on Content {\n        url\n        public\n        label\n        createdBy {\n          id\n          name\n        }\n        event {\n          id\n          name\n        }\n      }\n    }\n  }\n"])));
/**
 * __useContentDetailsQuery__
 *
 * To run a query within a React component, call `useContentDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentDetailsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContentDetailsQuery(baseOptions) {
    return Apollo.useQuery(ContentDetailsDocument, baseOptions);
}
export function useContentDetailsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(ContentDetailsDocument, baseOptions);
}
export function refetchContentDetailsQuery(variables) {
    return { query: ContentDetailsDocument, variables: variables };
}
export var ContentListDocument = gql(templateObject_87 || (templateObject_87 = __makeTemplateObject(["\n  query ContentList {\n    contents {\n      ...ContentFields\n    }\n  }\n  ", "\n"], ["\n  query ContentList {\n    contents {\n      ...ContentFields\n    }\n  }\n  ", "\n"])), ContentFieldsFragmentDoc);
/**
 * __useContentListQuery__
 *
 * To run a query within a React component, call `useContentListQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentListQuery({
 *   variables: {
 *   },
 * });
 */
export function useContentListQuery(baseOptions) {
    return Apollo.useQuery(ContentListDocument, baseOptions);
}
export function useContentListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(ContentListDocument, baseOptions);
}
export function refetchContentListQuery(variables) {
    return { query: ContentListDocument, variables: variables };
}
export var CreateContentPageDocument = gql(templateObject_88 || (templateObject_88 = __makeTemplateObject(["\n  query CreateContentPage {\n    events {\n      id\n      name\n    }\n  }\n"], ["\n  query CreateContentPage {\n    events {\n      id\n      name\n    }\n  }\n"])));
/**
 * __useCreateContentPageQuery__
 *
 * To run a query within a React component, call `useCreateContentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateContentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateContentPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateContentPageQuery(baseOptions) {
    return Apollo.useQuery(CreateContentPageDocument, baseOptions);
}
export function useCreateContentPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(CreateContentPageDocument, baseOptions);
}
export function refetchCreateContentPageQuery(variables) {
    return { query: CreateContentPageDocument, variables: variables };
}
export var UpdateContentPageDocument = gql(templateObject_89 || (templateObject_89 = __makeTemplateObject(["\n  query UpdateContentPage($id: ID!) {\n    content(id: $id) {\n      ...ContentFields\n    }\n    events {\n      id\n      name\n    }\n  }\n  ", "\n"], ["\n  query UpdateContentPage($id: ID!) {\n    content(id: $id) {\n      ...ContentFields\n    }\n    events {\n      id\n      name\n    }\n  }\n  ", "\n"])), ContentFieldsFragmentDoc);
/**
 * __useUpdateContentPageQuery__
 *
 * To run a query within a React component, call `useUpdateContentPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpdateContentPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateContentPageQuery(baseOptions) {
    return Apollo.useQuery(UpdateContentPageDocument, baseOptions);
}
export function useUpdateContentPageLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(UpdateContentPageDocument, baseOptions);
}
export function refetchUpdateContentPageQuery(variables) {
    return { query: UpdateContentPageDocument, variables: variables };
}
export var CreateContentDocument = gql(templateObject_90 || (templateObject_90 = __makeTemplateObject(["\n  mutation CreateContent($input: CreateContentInput!) {\n    createContent(input: $input) {\n      content {\n        ...ContentFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateContent($input: CreateContentInput!) {\n    createContent(input: $input) {\n      content {\n        ...ContentFields\n      }\n    }\n  }\n  ", "\n"])), ContentFieldsFragmentDoc);
/**
 * __useCreateContentMutation__
 *
 * To run a mutation, you first call `useCreateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentMutation, { data, loading, error }] = useCreateContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateContentMutation(baseOptions) {
    return Apollo.useMutation(CreateContentDocument, baseOptions);
}
export var UpdateContentDocument = gql(templateObject_91 || (templateObject_91 = __makeTemplateObject(["\n  mutation UpdateContent($input: UpdateContentInput!) {\n    updateContent(input: $input) {\n      content {\n        ...ContentFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateContent($input: UpdateContentInput!) {\n    updateContent(input: $input) {\n      content {\n        ...ContentFields\n      }\n    }\n  }\n  ", "\n"])), ContentFieldsFragmentDoc);
/**
 * __useUpdateContentMutation__
 *
 * To run a mutation, you first call `useUpdateContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentMutation, { data, loading, error }] = useUpdateContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateContentMutation(baseOptions) {
    return Apollo.useMutation(UpdateContentDocument, baseOptions);
}
export var DeleteContentDocument = gql(templateObject_92 || (templateObject_92 = __makeTemplateObject(["\n  mutation DeleteContent($input: DeleteContentInput!) {\n    deleteContent(input: $input) {\n      content {\n        ...ContentFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation DeleteContent($input: DeleteContentInput!) {\n    deleteContent(input: $input) {\n      content {\n        ...ContentFields\n      }\n    }\n  }\n  ", "\n"])), ContentFieldsFragmentDoc);
/**
 * __useDeleteContentMutation__
 *
 * To run a mutation, you first call `useDeleteContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteContentMutation, { data, loading, error }] = useDeleteContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteContentMutation(baseOptions) {
    return Apollo.useMutation(DeleteContentDocument, baseOptions);
}
export var EventListDocument = gql(templateObject_93 || (templateObject_93 = __makeTemplateObject(["\n  query EventList {\n    events {\n      ...EventFields\n    }\n  }\n  ", "\n"], ["\n  query EventList {\n    events {\n      ...EventFields\n    }\n  }\n  ", "\n"])), EventFieldsFragmentDoc);
/**
 * __useEventListQuery__
 *
 * To run a query within a React component, call `useEventListQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventListQuery({
 *   variables: {
 *   },
 * });
 */
export function useEventListQuery(baseOptions) {
    return Apollo.useQuery(EventListDocument, baseOptions);
}
export function useEventListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(EventListDocument, baseOptions);
}
export function refetchEventListQuery(variables) {
    return { query: EventListDocument, variables: variables };
}
export var EventDetailsDocument = gql(templateObject_94 || (templateObject_94 = __makeTemplateObject(["\n  query EventDetails($eventId: ID!) {\n    event(id: $eventId) {\n      ...EventFields\n    }\n  }\n  ", "\n"], ["\n  query EventDetails($eventId: ID!) {\n    event(id: $eventId) {\n      ...EventFields\n    }\n  }\n  ", "\n"])), EventFieldsFragmentDoc);
/**
 * __useEventDetailsQuery__
 *
 * To run a query within a React component, call `useEventDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventDetailsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useEventDetailsQuery(baseOptions) {
    return Apollo.useQuery(EventDetailsDocument, baseOptions);
}
export function useEventDetailsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(EventDetailsDocument, baseOptions);
}
export function refetchEventDetailsQuery(variables) {
    return { query: EventDetailsDocument, variables: variables };
}
export var CreateEventDocument = gql(templateObject_95 || (templateObject_95 = __makeTemplateObject(["\n  mutation CreateEvent($input: CreateEventInput!) {\n    createEvent(input: $input) {\n      event {\n        ...EventFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateEvent($input: CreateEventInput!) {\n    createEvent(input: $input) {\n      event {\n        ...EventFields\n      }\n    }\n  }\n  ", "\n"])), EventFieldsFragmentDoc);
/**
 * __useCreateEventMutation__
 *
 * To run a mutation, you first call `useCreateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventMutation, { data, loading, error }] = useCreateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEventMutation(baseOptions) {
    return Apollo.useMutation(CreateEventDocument, baseOptions);
}
export var UpdateEventDocument = gql(templateObject_96 || (templateObject_96 = __makeTemplateObject(["\n  mutation UpdateEvent($input: UpdateEventInput!) {\n    updateEvent(input: $input) {\n      event {\n        ...EventFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateEvent($input: UpdateEventInput!) {\n    updateEvent(input: $input) {\n      event {\n        ...EventFields\n      }\n    }\n  }\n  ", "\n"])), EventFieldsFragmentDoc);
/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions) {
    return Apollo.useMutation(UpdateEventDocument, baseOptions);
}
export var DeleteEventDocument = gql(templateObject_97 || (templateObject_97 = __makeTemplateObject(["\n  mutation DeleteEvent($input: DeleteEventInput!) {\n    deleteEvent(input: $input) {\n      event {\n        ...EventFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation DeleteEvent($input: DeleteEventInput!) {\n    deleteEvent(input: $input) {\n      event {\n        ...EventFields\n      }\n    }\n  }\n  ", "\n"])), EventFieldsFragmentDoc);
/**
 * __useDeleteEventMutation__
 *
 * To run a mutation, you first call `useDeleteEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEventMutation, { data, loading, error }] = useDeleteEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteEventMutation(baseOptions) {
    return Apollo.useMutation(DeleteEventDocument, baseOptions);
}
export var HomeOrganizationsDocument = gql(templateObject_98 || (templateObject_98 = __makeTemplateObject(["\n  query HomeOrganizations {\n    organizations {\n      id\n      name\n    }\n  }\n"], ["\n  query HomeOrganizations {\n    organizations {\n      id\n      name\n    }\n  }\n"])));
/**
 * __useHomeOrganizationsQuery__
 *
 * To run a query within a React component, call `useHomeOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomeOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomeOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomeOrganizationsQuery(baseOptions) {
    return Apollo.useQuery(HomeOrganizationsDocument, baseOptions);
}
export function useHomeOrganizationsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(HomeOrganizationsDocument, baseOptions);
}
export function refetchHomeOrganizationsQuery(variables) {
    return { query: HomeOrganizationsDocument, variables: variables };
}
export var OrganizationDetailsDocument = gql(templateObject_99 || (templateObject_99 = __makeTemplateObject(["\n  query OrganizationDetails($organizationId: ID!) {\n    organization(id: $organizationId) {\n      ...OrganizationFields\n      members {\n        id\n        name\n        emails {\n          address\n        }\n      }\n    }\n    users {\n      id\n      name\n    }\n  }\n  ", "\n"], ["\n  query OrganizationDetails($organizationId: ID!) {\n    organization(id: $organizationId) {\n      ...OrganizationFields\n      members {\n        id\n        name\n        emails {\n          address\n        }\n      }\n    }\n    users {\n      id\n      name\n    }\n  }\n  ", "\n"])), OrganizationFieldsFragmentDoc);
/**
 * __useOrganizationDetailsQuery__
 *
 * To run a query within a React component, call `useOrganizationDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDetailsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationDetailsQuery(baseOptions) {
    return Apollo.useQuery(OrganizationDetailsDocument, baseOptions);
}
export function useOrganizationDetailsLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(OrganizationDetailsDocument, baseOptions);
}
export function refetchOrganizationDetailsQuery(variables) {
    return { query: OrganizationDetailsDocument, variables: variables };
}
export var OrganizationsListDocument = gql(templateObject_100 || (templateObject_100 = __makeTemplateObject(["\n  query OrganizationsList {\n    organizations {\n      ...OrganizationFields\n    }\n  }\n  ", "\n"], ["\n  query OrganizationsList {\n    organizations {\n      ...OrganizationFields\n    }\n  }\n  ", "\n"])), OrganizationFieldsFragmentDoc);
/**
 * __useOrganizationsListQuery__
 *
 * To run a query within a React component, call `useOrganizationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationsListQuery(baseOptions) {
    return Apollo.useQuery(OrganizationsListDocument, baseOptions);
}
export function useOrganizationsListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(OrganizationsListDocument, baseOptions);
}
export function refetchOrganizationsListQuery(variables) {
    return { query: OrganizationsListDocument, variables: variables };
}
export var CreateOrganizationDocument = gql(templateObject_101 || (templateObject_101 = __makeTemplateObject(["\n  mutation CreateOrganization($input: CreateOrganizationInput!) {\n    createOrganization(input: $input) {\n      organization {\n        ...OrganizationFields\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation CreateOrganization($input: CreateOrganizationInput!) {\n    createOrganization(input: $input) {\n      organization {\n        ...OrganizationFields\n      }\n    }\n  }\n  ", "\n"])), OrganizationFieldsFragmentDoc);
/**
 * __useCreateOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrganizationMutation, { data, loading, error }] = useCreateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOrganizationMutation(baseOptions) {
    return Apollo.useMutation(CreateOrganizationDocument, baseOptions);
}
export var UpdateOrganizationDocument = gql(templateObject_102 || (templateObject_102 = __makeTemplateObject(["\n  mutation UpdateOrganization($input: UpdateOrganizationInput!) {\n    updateOrganization(input: $input) {\n      organization {\n        ...OrganizationFields\n        members {\n          id\n        }\n      }\n    }\n  }\n  ", "\n"], ["\n  mutation UpdateOrganization($input: UpdateOrganizationInput!) {\n    updateOrganization(input: $input) {\n      organization {\n        ...OrganizationFields\n        members {\n          id\n        }\n      }\n    }\n  }\n  ", "\n"])), OrganizationFieldsFragmentDoc);
/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions) {
    return Apollo.useMutation(UpdateOrganizationDocument, baseOptions);
}
export var AddMemberDocument = gql(templateObject_103 || (templateObject_103 = __makeTemplateObject(["\n  mutation AddMember($input: AddOrganizationMembersInput!) {\n    addOrganizationMembers(input: $input) {\n      organization {\n        id\n        members {\n          id\n          firstName\n          lastName\n          emails {\n            address\n            verified\n          }\n        }\n      }\n    }\n  }\n"], ["\n  mutation AddMember($input: AddOrganizationMembersInput!) {\n    addOrganizationMembers(input: $input) {\n      organization {\n        id\n        members {\n          id\n          firstName\n          lastName\n          emails {\n            address\n            verified\n          }\n        }\n      }\n    }\n  }\n"])));
/**
 * __useAddMemberMutation__
 *
 * To run a mutation, you first call `useAddMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addMemberMutation, { data, loading, error }] = useAddMemberMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddMemberMutation(baseOptions) {
    return Apollo.useMutation(AddMemberDocument, baseOptions);
}
export var RemoveOrganizationMembersDocument = gql(templateObject_104 || (templateObject_104 = __makeTemplateObject(["\n  mutation RemoveOrganizationMembers($input: RemoveOrganizationMembersInput!) {\n    removeOrganizationMembers(input: $input) {\n      organization {\n        id\n        members {\n          id\n        }\n      }\n    }\n  }\n"], ["\n  mutation RemoveOrganizationMembers($input: RemoveOrganizationMembersInput!) {\n    removeOrganizationMembers(input: $input) {\n      organization {\n        id\n        members {\n          id\n        }\n      }\n    }\n  }\n"])));
/**
 * __useRemoveOrganizationMembersMutation__
 *
 * To run a mutation, you first call `useRemoveOrganizationMembersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveOrganizationMembersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeOrganizationMembersMutation, { data, loading, error }] = useRemoveOrganizationMembersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveOrganizationMembersMutation(baseOptions) {
    return Apollo.useMutation(RemoveOrganizationMembersDocument, baseOptions);
}
export var CategoryListDocument = gql(templateObject_105 || (templateObject_105 = __makeTemplateObject(["\n  query CategoryList {\n    categories {\n      ...CategoryFields\n    }\n  }\n  ", "\n"], ["\n  query CategoryList {\n    categories {\n      ...CategoryFields\n    }\n  }\n  ", "\n"])), CategoryFieldsFragmentDoc);
/**
 * __useCategoryListQuery__
 *
 * To run a query within a React component, call `useCategoryListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCategoryListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCategoryListQuery({
 *   variables: {
 *   },
 * });
 */
export function useCategoryListQuery(baseOptions) {
    return Apollo.useQuery(CategoryListDocument, baseOptions);
}
export function useCategoryListLazyQuery(baseOptions) {
    return Apollo.useLazyQuery(CategoryListDocument, baseOptions);
}
export function refetchCategoryListQuery(variables) {
    return { query: CategoryListDocument, variables: variables };
}
export var CollectActivityDocument = gql(templateObject_106 || (templateObject_106 = __makeTemplateObject(["\n  mutation CollectActivity($input: CollectActivityInput!) {\n    collectActivity(input: $input) {\n      code\n      success\n      message\n    }\n  }\n"], ["\n  mutation CollectActivity($input: CollectActivityInput!) {\n    collectActivity(input: $input) {\n      code\n      success\n      message\n    }\n  }\n"])));
/**
 * __useCollectActivityMutation__
 *
 * To run a mutation, you first call `useCollectActivityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCollectActivityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [collectActivityMutation, { data, loading, error }] = useCollectActivityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCollectActivityMutation(baseOptions) {
    return Apollo.useMutation(CollectActivityDocument, baseOptions);
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79, templateObject_80, templateObject_81, templateObject_82, templateObject_83, templateObject_84, templateObject_85, templateObject_86, templateObject_87, templateObject_88, templateObject_89, templateObject_90, templateObject_91, templateObject_92, templateObject_93, templateObject_94, templateObject_95, templateObject_96, templateObject_97, templateObject_98, templateObject_99, templateObject_100, templateObject_101, templateObject_102, templateObject_103, templateObject_104, templateObject_105, templateObject_106;
//# sourceMappingURL=graphql.js.map